import { styled } from '@mui/material';
import { Flex } from '../../../base/Flex';
import { colorPalettes } from '../../../../context/theme';
import { LINE_HEIGHT, PADDING, SIZES } from '../../../../constants/sizes';

export const StyledLogout = styled.div`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.text.logout};
`;

export const StyledLogoutContent = styled(Flex)`
  justify-content: center;
  padding: ${PADDING['large']};
  font-size: ${SIZES['small']};
  line-height: ${LINE_HEIGHT['small']};
`;

export const StyledLogoutIcon = styled.div`
  padding-right: 0.3846rem;
  cursor: pointer;
`;

export const StyledLogoutText = styled.div`
  cursor: pointer;
`;
